export default "__VITE_ASSET__DBE0TH0U__"